import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const myRouter = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      redirect: '/shippingDate'
    },
    {
      path: '/shippingDate',
      name: 'shippingDate',
      component: () => import('@/views/shippingDate/index.vue')
    },
    {
      path: '/dynamicsTrack',
      name: 'dynamicsTrack',
      component: () => import('@/views/shipBox/index.vue')
    },
    {
      path: '/shipTracking',
      name: 'shipTracking',
      component: () => import('@/views/shipBox/ShipTracking.vue')
    },
    {
      path: '/shippingDate_en',
      name: 'shippingDate_en',
      component: () => import('@/views/english/shippingDate/index.vue')
    },
    {
      path: '/dynamicsTrack_en',
      name: 'dynamicsTrack_en',
      component: () => import('@/views/english/shipBox/index.vue')
    },
    {
      path: '/shipTracking_en',
      name: 'shipTracking_en',
      component: () => import('@/views/english/shipBox/ShipTracking.vue')
    },
    {
      path: '/404',
      name: '404',
      component: () => import('@/views/error/404.vue')
    },
    {
      path: '/500',
      name: '500',
      component: () => import('@/views/error/500.vue')
    },
    {
      path: '*',
      redirect: '/404'
    }
  ]
})

// 路由守卫
myRouter.beforeEach((to, from, next) => {
  next()
})

export default myRouter
